import React from 'react';

const MatchAcceptedView = ({ profile, trail, matches, onContinue, user }) => {
    const formatDisplayDate = (timestamp) => {
        const date = timestamp.toDate();
        const options = { 
            weekday: 'long', 
            month: 'long', 
            day: 'numeric' 
        };
        return date.toLocaleDateString('en-US', options);
    };

    const formatTime = (timestamp) => {
        return timestamp.toDate().toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    // Find the corresponding match from the matches state
    const match = matches?.find(m => (
        // Check both combinations of profile IDs
        ((m.profile_ids.id1 === profile.id && m.profile_ids.id2 === user.uid) ||
         (m.profile_ids.id2 === profile.id && m.profile_ids.id1 === user.uid)) &&
        m.trail_id === trail.id &&
        m.status === 'confirmed'
    ));

    // Add error handling for debugging
    if (!match) {
        console.log('Match not found. Debug info:', {
            profileId: profile.id,
            trailId: trail.id,
            availableMatches: matches,
        });
    }

    return (
        <div className="min-h-screen bg-white p-6 flex flex-col items-center justify-center">
            <h2 className="text-2xl font-bold mb-2">Match Accepted!</h2>
            <p className="text-gray-600 mb-8">Your session is booked.</p>
            <div className="w-full mb-8">
                <p className="font-semibold mb-4">Partner: {profile.name}</p>
                <p className="font-semibold mb-4">Gender: {profile.gender}</p>
                <div className="space-y-2">
                    <p>• Trail: {trail.name}</p>
                    <p>• Length: {trail.length}</p>
                    <p>• Difficulty: {trail.difficulty}</p>
                    <p>• Date: {match ? formatDisplayDate(match.start_time) : 'Date not available'}</p>
                    <p>• Time: {match ? `${formatTime(match.start_time)} to ${formatTime(match.end_time)}` : 'Time not available'}</p>
                    <p>• Location: {trail.location}</p>
                </div>
            </div>
            <button
                onClick={onContinue}
                className="w-full bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-full py-3 font-semibold"
            >
                Continue
            </button>
        </div>
    );
};

export default MatchAcceptedView; 